import paper from "paper";
import { trace_options } from "./constants.js";
import { outlineProcessing } from "./outline_process.js";
import { removeBlankElements } from "./path_fns.js";
import { getSVGFromRasterTracing, getSVGFromRasterTracing2 } from "./raster_tracing.js";
import { canvasEvent, drawRaster, loadImage, makePaperProject, removeChildren } from "./utils.js";

export const getOutlinePathsFromImg = async (img_src, append_el = null) => {
  return await getOutlinePath({
    img_src,
    append_el,
    with_path_simplify: false,
    smoothPercentage: 0,
    img_el: null,
    binarize_threshold: 0.01,
  });
};

export const getOutlinePathsFromImgWithAdaptiveSimplify = async (
  img_src,
  append_el = null,
  smoothPercentage,
  img_el,
  binarize_threshold
) => {
  return await getOutlinePath({
    img_src,
    append_el,
    with_path_simplify: true,
    smoothPercentage,
    img_el,
    binarize_threshold,
  });
};

export const getOutlinePath = async ({
  img_src,
  append_el = null,
  with_path_simplify,
  smoothPercentage,
  binarize_threshold,
  img_el,
}) => {
  const paper_scope = new paper.PaperScope();
  paper_scope.activate();
  append_el && removeChildren(append_el);

  //==========================================================================//
  //  Load Image From Src
  //==========================================================================//
  const image_el = img_el || (await loadImage(img_src));

  //=====================================================//
  //  Raster Outline Tracing, then Create SVG Element
  //=====================================================//
  if (smoothPercentage) {
    Object.assign(trace_options, { smoothPercentage });
  }
  if (binarize_threshold) {
    Object.assign(trace_options, { binarize_threshold });
  }
  const trace_svg = await getSVGFromRasterTracing({ image_el, trace_options });

  //==========================================================================//
  //  Create Paper Project on DOM Canvas
  //==========================================================================//
  makePaperProject(paper_scope, image_el.width, image_el.height, append_el);

  //=====================================================//
  // paperjs 윤곽선 import
  //=====================================================//
  let outline_paths;

  return new Promise((resolve, reject) => {
    paper_scope.project.importSVG(trace_svg, {
      onLoad: () => {
        if (append_el) {
          drawRaster(paper_scope, image_el, 0.9);
          canvasEvent(paper_scope);
        }

        // const before_seg = countsAllPathSegments({ paper_scope });
        outline_paths = outlineProcessing({
          paper_scope,
          is_set_style: !!append_el,
          is_process_simplify: with_path_simplify,
        });
        // const after_seg = countsAllPathSegments({ paper_scope });

        // console.log("segment 변화", {
        //   "처리 전": before_seg,
        //   "처리 후": after_seg,
        //   감소율: -Math.round(((before_seg - after_seg) / before_seg) * 100),
        // });

        outline_paths.name = "outline_item";
        removeBlankElements(paper_scope);
        const outline_item = {
          name: outline_paths.name,
          length: Math.round(outline_paths.length),
          area: Math.round(outline_paths.area),
          paper_obj: outline_paths,
          path_data: outline_paths.pathData,
        };
        // console.log("outline item", outline_item);
        return resolve(outline_item);
      },
      onError: (e) => {
        reject(e);
      },
      expandShapes: false,
    });
  });
};

export const getOutlinePathsFromImg2 = async (img_src, append_el = null) => {
  const paper_scope = new paper.PaperScope();
  paper_scope.activate();
  append_el && removeChildren(append_el);

  //==========================================================================//
  //  Load Image From Src
  //==========================================================================//
  const image_el = await loadImage(img_src);

  //=====================================================//
  //  Raster Outline Tracing, then Create SVG Element
  //=====================================================//
  const trace_svg = await getSVGFromRasterTracing2({
    image_el,
    trace_options: {
      color: [0.0, 0.0, 0.0],
      is_alpha_binarize: false,
      threshold: 0.1,
    },
  });

  //==========================================================================//
  //  Create Paper Project on DOM Canvas
  //==========================================================================//
  makePaperProject(paper_scope, image_el.width, image_el.height, append_el);

  //=====================================================//
  // paperjs 윤곽선 import
  //=====================================================//
  let outline_paths;
  paper_scope.project.importSVG(trace_svg, {
    onLoad: () => {
      if (append_el) {
        drawRaster(paper_scope, image_el, 0.9);
        canvasEvent(paper_scope);
      }
      outline_paths = outlineProcessing({
        paper_scope,
        is_set_style: !!append_el,
        is_process_simplify: true,
      });

      outline_paths.name = "outline_item";

      removeBlankElements(paper_scope);
    },
    expandShapes: false,
  });
  const outline_item = {
    name: outline_paths.name,
    length: Math.round(outline_paths.length),
    area: Math.round(outline_paths.area),
    paper_obj: outline_paths,
    path_data: outline_paths.pathData,
  };
  // console.log("outline item", outline_item);
  return Promise.resolve(outline_item);
};
